<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<mat-form-field class="new-exp-form-field" [formGroup]="valuesForm">
  <mat-label>{{fieldLabel}}</mat-label>
  <mat-chip-grid #chipGrid formControlName="valuesList">
    <mat-chip-row *ngFor="let value of values" (removed)="remove(value)">
      {{value}}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input [placeholder]="placeHolderLabel"
           [matChipInputFor]="chipGrid"
           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
           [matChipInputAddOnBlur]="addOnBlur"
           (matChipInputTokenEnd)="add($event)"/>
  </mat-chip-grid>
  <mat-error *ngIf="isEmpty()" i18n>At least one element must exist.</mat-error>
</mat-form-field>
